import { faFile } from '@fortawesome/free-regular-svg-icons'
import { faFile as faFileDisabled } from '@fortawesome/free-solid-svg-icons'
import React, { useMemo } from 'react'

import { isSelfServeTier } from '@/components/GoodlordControl/utils'
import IconButton from '@/components/IconButton'
import type { ReferenceTier } from '@/lib/apollo/query/get-applicant'
import type { Document } from '@/types/Activity'
import type { Application } from '@/types/Activity'
import { OverallOutcomeStatus } from '@/types/Outcome'
import { isFinalOverallOutcome } from '@/utils/outcome'

interface Props {
  referenceTier?: ReferenceTier
  application: Application
}

const ViewReport = ({ application, referenceTier }: Props) => {
  const overallOutcome = application?.outcome?.status

  const reportFileName: Document | null = useMemo(() => {
    if (
      !application ||
      !application.context ||
      !application.context?.documents ||
      !(application.context?.documents.length > 0)
    ) {
      return null
    }
    const foundReport = application.context.documents.find(
      ({ specifiedType }) => specifiedType === 'Reference Report',
    )
    if (foundReport) {
      return foundReport
    }
    return null
  }, [application])

  const isCorrectOutcomeForReport = isSelfServeTier(referenceTier)
    ? true
    : isFinalOverallOutcome(overallOutcome) &&
      overallOutcome !== OverallOutcomeStatus.reOpened

  const isButtonEnabled =
    reportFileName && reportFileName.fileName && isCorrectOutcomeForReport

  const onClick = () => {
    if (reportFileName && reportFileName.fileName) {
      window.open(`${reportFileName.fileName}`, '_blank')
    }
  }

  return (
    <IconButton
      tooltipMessage={
        isButtonEnabled ? 'View report' : 'Report available once outcome is given '
      }
      icon={faFile}
      onClick={onClick}
      disabled={!isButtonEnabled}
      disabledIcon={faFileDisabled}
    />
  )
}

export default ViewReport
